import React, { useCallback } from 'react';
import styled from 'styled-components';
import { ListItemText } from '@mui/material';
import dayjs from 'dayjs';
import Checkbox from '../../Checkbox';
import DateRangePicker, { DateRangeValue } from '../../DateRangePicker';
import MenuItemStyled from '../../DropDown/shared/MenuItemStyled';
import { FlexCenter } from '../../Flex';
import { Divider } from '../../FormControls/FormControls';

const StyledDateRangePickerFilter = styled(FlexCenter)`
  width: 330px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  li {
    padding-left: 0;
  }
`;

type Props = {
  emptyValueLabel?: string;
  range?: string | string[];
  onChange?: (v: Array<string>) => void;
};

const DateRangeTableFilter = ({ emptyValueLabel, range, onChange }: Props) => {
  const handleChange = useCallback(
    (v: DateRangeValue) => {
      onChange?.([
        v.start?.format('L') || '',
        v.end?.format('L') || '',
        range?.[2] || '',
      ]);
    },
    [onChange, range],
  );

  const handleCheckboxChange = useCallback(() => {
    // reset filter when from/to are null and No run time is set to false
    if (range?.[2] === 'true' && !range?.[0] && !range?.[1])
      return onChange?.([]);

    return onChange?.([
      range?.[0] || '',
      range?.[1] || '',
      `${range?.[2] !== 'true'}`,
    ]);
  }, [range, onChange]);

  return (
    <StyledDateRangePickerFilter>
      <DateRangePicker
        disableFuture
        fromLabel="From"
        toLabel="To"
        format="L"
        value={{
          start: range?.[0] ? dayjs(range[0]) : null,
          end: range?.[1] ? dayjs(range[1]) : null,
        }}
        onChange={handleChange}
      />

      {!!emptyValueLabel && (
        <>
          <Divider />

          <MenuItemStyled sx={{ width: '100%' }} onClick={handleCheckboxChange}>
            <Checkbox checked={range?.[2] === 'true'} />
            <ListItemText primary={emptyValueLabel} />
          </MenuItemStyled>
        </>
      )}
    </StyledDateRangePickerFilter>
  );
};

export default DateRangeTableFilter;
